import React from 'react';
import styled from 'styled-components';
import { PRIMARY_COLOR } from '../../core/constants';

const Footer = styled.div`
  margin: 0px;
  width: 100%;
`;

const FooterContent = styled.div`
  position: relative;
  background: ${PRIMARY_COLOR};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-bottom: 30px;
  margin-top: -1px;
  flex-direction: column;
`;

const Copyright = styled.p`
  font-size: 16px;
  color: white;
`;

const IconsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

const Outro: React.FC = () => {
  return (
    <Footer>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="rgb(239, 44, 58, 0.5)"
          d="M0,64L48,96C96,128,192,192,288,208C384,224,480,192,576,160C672,128,768,96,864,85.3C960,75,1056,85,1152,80C1248,75,1344,53,1392,42.7L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />
        <path
          fill={PRIMARY_COLOR}
          fillOpacity="1"
          d="M0,84L18,96C96,158,192,192,288,208C384,224,480,192,576,160C672,128,768,106,864,95.3C960,85,1056,95,1152,85C1248,75,1344,53,1392,42.7L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />
      </svg>

      <FooterContent>
        <Copyright>
          {`© Copyright ${new Date().getFullYear()} Deevent`}
        </Copyright>
        <IconsContainer>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/company/deevent"
            style={{ marginRight: 10 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <title>LinkedIn profile</title>
              <path
                fill="#fff"
                d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
              />
            </svg>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="mailto:info@deevent.app"
            style={{ marginRight: 10 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <title>Send an email</title>
              <path
                fill="#fff"
                d="M12 .02c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.99 6.98l-6.99 5.666-6.991-5.666h13.981zm.01 10h-14v-8.505l7 5.673 7-5.672v8.504z"
              />
            </svg>
          </a>
        </IconsContainer>
      </FooterContent>
    </Footer>
  );
};

export default Outro;
